/* unplugin-vue-components disabled */import script from "./Zscq.vue?vue&type=script&lang=ts&setup=true"
export * from "./Zscq.vue?vue&type=script&lang=ts&setup=true"

import "./Zscq.vue?vue&type=style&index=0&id=595e0232&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595e0232"]])

export default __exports__